module.exports = __webpack_public_path__ + "static/media/nyhome.e039231c.png";